import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { MonModalService } from '../services/mon-modal/mon-modal.service';
import { TranslateService } from '@client/app/services/translate/translate.service';


@Directive({
    selector: '[monModalConfirm]',
    standalone: false,
})
export class ModalConfirmDirective {
    @Input('monModalConfirm') confirmMessage: string = '';
    // eslint-disable-next-line
    @Output('monModalConfirmAction') actionOK = new EventEmitter<void>();
    @Output('monModalConfirmActionCancel') actionCancel = new EventEmitter<void>();
    constructor (private monModalService: MonModalService, private translateService: TranslateService) {}

    @HostListener('click')
    onClick (event: Event): void {
        const msg = this.confirmMessage || this.translateService.getString('Are you sure?');

        this.monModalService.confirm(msg)
            .then((result) => {
                this.actionOK.emit();
            }).catch(() => {
                this.actionCancel.emit();
            });
    }
}
